import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const IconButton = styled.div`
  position: relative;
  padding: ${pxToRem(5)};
  height: ${pxToRem(76)};
  width: ${pxToRem(76)};
  path {
    stroke-width: 0.5;
  }
  &[disabled] {
    color: #eff0f0;
  }
  &:not([disabled]):hover {
    background: #eff0f0;
  }
  &[data-icon-selected] {
    background: #eaf4fa;
    pointer-events: none;
  }
`;
